const TextAlignRight: React.FC<any> = ({ size, ...props }) => (
  <svg viewBox="0 0 20 20" fill="currentColor" width={size || '20'} height={size || '20'} {...props} fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2">
    <path d="M18,4.442c0,-0.414 -0.336,-0.75 -0.75,-0.75l-14.5,0c-0.414,0 -0.75,0.336 -0.75,0.75c0,0.414 0.336,0.75 0.75,0.75l14.5,0c0.414,0 0.75,-0.336 0.75,-0.75Z" />
    <path d="M18,10.012c0,-0.414 -0.336,-0.75 -0.75,-0.75l-10.5,-0c-0.414,-0 -0.75,0.336 -0.75,0.75c0,0.414 0.336,0.75 0.75,0.75l10.5,-0c0.414,-0 0.75,-0.336 0.75,-0.75Z" />
    <path d="M18,15.547c0,-0.414 -0.336,-0.75 -0.75,-0.75l-8.5,0c-0.414,0 -0.75,0.336 -0.75,0.75c0,0.414 0.336,0.75 0.75,0.75l8.5,0c0.414,0 0.75,-0.336 0.75,-0.75Z" />
  </svg>
);

export default TextAlignRight;
